import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiError(e) {
  const detail = e?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((d) => (d && typeof d.msg === "string" ? d.msg : ""))
      .filter(Boolean)
      .join(" ");
  }
  return e?.message || "Something went wrong. Please try again.";
}

export function track(eventType, payload = {}) {
  api
    .post("/analytics/events", { event_type: eventType, payload })
    .catch(() => {});
}

export function scrollToId(id) {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
}

export function getFingerprint() {
  let fp = localStorage.getItem("lyw_fp");
  if (!fp) {
    fp = crypto.randomUUID();
    localStorage.setItem("lyw_fp", fp);
  }
  return fp;
}
